module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-agreements"
  }, [_c('h4', [_vm._v(_vm._s(_vm.i18n[_vm.locale].notes_for) + " " + _vm._s(_vm.activeSchoolYear.name))]), _vm._v(" "), (_vm.userCanEditAgreementNote) ? _c('div', [_c('AppEIPWYZIWYG', {
    attrs: {
      "textInput": _vm.agreements
    },
    on: {
      "close": _vm.updateAgreements
    }
  })], 1) : _c('div', {
    staticClass: "user-agreements__notes"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.agreements)
    }
  }), _vm._v(" "), (_vm.agreements.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen noter")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5166ab48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/SubjectsDistributionUserAgreements.vue
// module id = 1916
// module chunks = 1